import { buildFeaturePageSearchHref } from "@/features/feature-page/build-feature-page-search-href";
import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

export function SearchCtaBlock({
  block,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "searchCta" }>;
}) {
  const href = buildFeaturePageSearchHref(block);
  return (
    <FeaturePageSection
      block={block}
      resolvedBackground={block.resolvedBackground}
      labelledById={`${block.id}-heading`}
    >
      <div className="rounded-3xl border border-primary/30 bg-primary/10 p-8 text-center md:p-14">
        <h2 id={`${block.id}-heading`} className="text-3xl font-bold tracking-tight sm:text-5xl">
          {block.title}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">{block.body}</p>
        <a
          href={href}
          // /search?… is noindex; /offers stays followed.
          rel={href.startsWith("/search") ? "nofollow" : undefined}
          className="mt-8 inline-flex min-h-12 items-center rounded-lg bg-primary px-6 font-bold text-primary-foreground shadow-sm transition hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background"
        >
          {block.label}
        </a>
      </div>
    </FeaturePageSection>
  );
}
